import { render } from "./FormTemplate.vue?vue&type=template&id=e8bf1ffe&scoped=true"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=e8bf1ffe&lang=scss&scoped=true"

import exportComponent from "d:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8bf1ffe"]])

export default __exports__